import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { FiStar } from "react-icons/fi";
import { useTranslation } from "react-i18next";

import image_1 from "../assets/images/product/outside/adoquines.png";
import image_2 from "../assets/images/product/outside/bordillos.png";
import image_3 from "../assets/images/product/outside/losas.jpg";
import image_4 from "../assets/images/product/outside/peldanos.jpg";
import image_5 from "../assets/images/product/outside/fences.png";
import image_6 from "../assets/images/product/outside/totem.png";
import image_7 from "../assets/images/product/outside/pasos.jpg";
import image_8 from "../assets/images/product/outside/piedras.jpg";
import image_9 from "../assets/images/product/outside/ambient.jpg";
import image_10 from "../assets/images/product/inside/losa.png";
import image_11 from "../assets/images/product/inside/plaqueta.png";
import image_12 from "../assets/images/product/inside/ducha.jpg";
import image_13 from "../assets/images/product/inside/shinck.png";
import image_14 from "../assets/images/product/inside/peldano.jpg";
import image_15 from "../assets/images/product/inside/encimera.png";
import image_16 from "../assets/images/product/inside/rodapie.png";
import image_17 from "../assets/images/product/inside/baldosa.png";
import image_18 from "../assets/images/product/inside/ambient.png";
import image_19 from "../assets/images/product/facades/pegada.jpg";
import image_20 from "../assets/images/product/facades/ventilada.png";
import image_21 from "../assets/images/product/facades/lou.jpg";
import image_22 from "../assets/images/product/facades/premontada.png";
import image_23 from "../assets/images/product/facades/rustica.png";
import image_24 from "../assets/images/product/facades/flexible.jpg";
import image_25 from "../assets/images/product/facades/ambient.png";
import image_26 from "../assets/images/product/pools/green.png";
import image_27 from "../assets/images/product/pools/luto.png";
import image_28 from "../assets/images/product/pools/grey.png";
import image_29 from "../assets/images/product/pools/terra.png";
import image_30 from "../assets/images/product/pools/goldenp.png";
import image_31 from "../assets/images/product/pools/goldenb.png";
import image_32 from "../assets/images/product/pools/ambient.png";
import image_33 from "../assets/images/product/finishes/Imagen1.jpg";
import image_34 from "../assets/images/product/finishes/Imagen2.png";
import image_35 from "../assets/images/product/finishes/Imagen3.png";
import image_36 from "../assets/images/product/finishes/Imagen4.png";
import image_37 from "../assets/images/product/finishes/Imagen5.png";
import image_38 from "../assets/images/product/finishes/Imagen6.png";
import image_39 from "../assets/images/product/finishes/Imagen7.png";
import image_40 from "../assets/images/product/finishes/Imagen8.png";
import image_41 from "../assets/images/product/finishes/Imagen9.png";
import image_42 from "../assets/images/product/finishes/Imagen10.png";
import image_43 from "../assets/images/product/custom/Imagen1.jpg";
import image_44 from "../assets/images/product/custom/Imagen2.jpg";
import image_45 from "../assets/images/product/custom/Imagen3.png";
import image_46 from "../assets/images/product/custom/Imagen4.jpg";
import image_47 from "../assets/images/product/custom/Imagen5.jpg";
import image_48 from "../assets/images/product/custom/Imagen6.jpg";
import image_49 from "../assets/images/product/custom/Imagen7.jpg";
import image_50 from "../assets/images/product/custom/Imagen8.png";
import image_51 from "../assets/images/product/custom/Imagen9.png";
import image_52 from "../assets/images/product/custom/Imagen10.png";
import image_53 from "../assets/images/product/custom/Imagen11.jpg";
import image_54 from "../assets/images/product/custom/Imagen12.png";
import image_55 from "../assets/images/product/custom/Imagen13.png";
import image_56 from "../assets/images/product/custom/Imagen14.jpg";

const ProductPhotos = ({ slug }) => {
    const { t } = useTranslation();
    const selectedSlug = slug || useParams().slug;

    const productCollections = {
        exterior: {
            ambient: image_9,
            items: [
                { title: t("adoquines"), image: image_1 },
                { title: t("bordillos"), image: image_2 },
                { title: t("losas"), image: image_3 },
                { title: t("peldaños"), image: image_4 },
                { title: t("fences"), image: image_5 },
                { title: t("totem"), image: image_6 },
                { title: t("pasos"), image: image_7 },
                { title: t("piedras"), image: image_8 },
            ],
        },
        interior: {
            ambient: image_18,
            items: [
                { title: t("losa"), image: image_10 },
                { title: t("plaqueta"), image: image_11 },
                { title: t("ducha"), image: image_12 },
                { title: t("fregadero"), image: image_13 },
                { title: t("peldaño"), image: image_14 },
                { title: t("encimera"), image: image_15 },
                { title: t("rodapie"), image: image_16 },
                { title: t("baldosas"), image: image_17 },
            ],
        },
        facades: {
            ambient: image_25,
            items: [
                { title: t("pegada"), image: image_19 },
                { title: t("ventilada"), image: image_20 },
                { title: t("lou"), image: image_21 },
                { title: t("premontada"), image: image_22 },
                { title: t("rustica"), image: image_23 },
                { title: t("flexible"), image: image_24 },
            ],
        },
        pools: {
            ambient: image_32,
            items: [
                { title: t("green"), image: image_26 },
                { title: t("lugo"), image: image_27 },
                { title: t("gray"), image: image_28 },
                { title: t("terra"), image: image_29 },
                { title: t("goldenPink"), image: image_30 },
                { title: t("goldenBlue"), image: image_31 },
            ],
        },
        custom: {
            items: [
                { title: t("vaciados"), image: image_43 },
                { title: t("g-formato"), image: image_44 },
                { title: t("g-formato"), image: image_45 },
                { title: t("especiales"), image: image_46 },
                { title: t("formas-textos"), image: image_47 },
                { title: t("platos-ducha"), image: image_48 },
                { title: t("fregadero"), image: image_13 },
                { title: t("lavamanos"), image: image_49 },
                { title: t("encimera"), image: image_15 },
                { title: t("hexagonal"), image: image_50 },
                { title: t("rounded"), image: image_51 },
                { title: t("mobiliario"), image: image_52 },
                { title: t("piezas-solidas"), image: image_53 },
                { title: t("piramidal"), image: image_54 },
                { title: t("bloques"), image: image_55 },
                { title: t("oval"), image: image_56 },
            ],
        },
        finishes: {
            items: [
                { title: t("negro"), image: image_33 },
                { title: t("verde"), image: image_34 },
                { title: t("gris"), image: image_35 },
                { title: t("dorado"), image: image_36 },
            ],
        },
        finishes_1: {
            items: [
                { title: t("natural"), image: image_37 },
                { title: t("serrado"), image: image_38 },
                { title: t("envejecido"), image: image_39 },
                { title: t("pulidos"), image: image_40 },
                { title: t("envejecido"), image: image_41 },
                { title: t("pulidos"), image: image_42 },
            ],
        },
    };

    const collection = productCollections[selectedSlug];
    const itemCount = collection.items.length;

    const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 768);

    useEffect(() => {
        const handleResize = () => {
            setIsDesktop(window.innerWidth >= 768);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    let columns = 2;
    if (itemCount === 6) columns = 3;
    else if (itemCount >= 7) columns = 4;

    const gridStyle = isDesktop
        ? { gridTemplateColumns: `repeat(${columns}, 1fr)` }
        : undefined;

    return (
        <div className="product-grid-container">
            <div className="product-grid" style={gridStyle}>
                {collection.items.map((item, index) => (
                    <div key={index} className="product-card">
                        <img src={item.image} alt={item.title} />
                        <div className="product-label">
                            <FiStar className="icon" />
                            <span>{item.title}</span>
                        </div>
                    </div>
                ))}
            </div>

            {/* Mostrar ambient solo si no es finishes ni finishes_1 */}
            {!(selectedSlug === "custom" || selectedSlug === "finishes" || selectedSlug === "finishes_1") && (
                <div className="ambient-container">
                    <img
                        src={collection.ambient}
                        alt={t("ambienteDecorativo")}
                        className="ambient-image"
                    />
                </div>
            )}
        </div>
    );
};

export default ProductPhotos;
